import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class EventIndexRoute extends Route 
{
	@service ajax;
	@service store;
	
	async model(params) 
	{
		const event = await this.ajax.request("event");
		let type = this.store.modelFor('event');
		let serializer = this.store.serializerFor('event');
		this.store.push(serializer.normalizeSingleResponse(this.store, type, event, event.data.id));
		
		const classGroups = await this.ajax.request("class-groups");
		type = this.store.modelFor('classGroup');
		serializer = this.store.serializerFor('classGroup');
		this.store.push(serializer.normalizeArrayResponse(this.store, type, classGroups));
			
		return this.store.peekRecord('Event', event.data.id);
	}
}
